(ns rothko.editor.behaviours.delete
  (:require [com.rpl.specter :as sp]
            [rothko.editor.behaviours.backspace :as backspace-behaviour]
            [rothko.editor.document.navigators :as n]
            [rothko.editor.actions :as actions]
            [rothko.editor.util :as util :include-macros true]))

(defn transform
  [opts]
  [(sp/collect-one :selection)
   n/token-unbias
   (n/if-caret?

    ;; Caret
    (util/cond-path

     (n/or-paths n/end-of-script? n/empty-document?)
     [sp/DISPENSE
      actions/no-op]

     (constantly :else)
     (sp/multi-path
      (n/expand-selection
       {:shift-start-offset 1
        :shift-end-offset 1
        :caret? true})
      (sp/with-fresh-collected
        [(sp/collect-one :selection)
         (backspace-behaviour/transform-caret (assoc opts :move :right))])
      n/token-rebias))

    ;; Selection
    (sp/multi-path (backspace-behaviour/transform-selection opts)
                   n/token-rebias))])
